import classNames from "classnames";

const Vinjett = ({
  content,
  size = "large",
}: {
  content?: string;
  size?: string;
}) => (
  <div
    className={classNames(
      "absolute top-0 left-0 bg-red-700 text-static-white uppercase italic text-center font-bold z-10",
      {
        "text-sm py-1 px-2": size === "small",
        "text-base py-2 px-4": size === "medium",
        "text-base md:text-xl py-2 px-4": size === "large",
      },
    )}
  >
    {content}
  </div>
);
export default Vinjett;
